import { NavBarTop } from '../../components-common/layout';
import { IRootieComponent, RootieComponentType } from '../../components-system';
import { assignmentRoutes } from '../assignments/_routes';
import { buildingConfigurationsRoutes } from '../building-configurations/_routes';
import { componentDbRoutes } from '../components-db/components/shared';
import { coursesRoutes } from '../courses/_routes';
import { lecturersAreaRoutes } from '../lecturers/routes';
import { managementAreaRoutes } from '../management/routes';
import { studentsAreaRoutes } from '../students/routes';

const teacherLinks = [
  coursesRoutes.index,
  managementAreaRoutes.users,
  managementAreaRoutes.analytics,
  componentDbRoutes.dashboard,
  buildingConfigurationsRoutes.index,
];

export const menuTop = {
  STUDY_DIRECTOR: [managementAreaRoutes.dashboard, ...teacherLinks],
  LECTURER: [lecturersAreaRoutes.dashboard, ...teacherLinks],
  STUDENT: [
    studentsAreaRoutes.dashboard,
    coursesRoutes.index,
    assignmentRoutes.index,
    componentDbRoutes.dashboard,
    buildingConfigurationsRoutes.index,
  ],
};

export const sectionHeader = {
  id: 'header',
  components: [
    {
      id: 'top_bar',
      cat: 'menu',
      type: 'icons',
      Component: NavBarTop,
      props: {
        menuItems: [],
        route: '/',
      },
      actions: [
        {
          operation: 'replace_by_Key',
          prop: 'menuItems',
          value: menuTop,
          condition: {
            prop: 'role',
            value: ['STUDENT', 'LECTURER', 'STUDY_DIRECTOR'],
          },
        },
      ],
    } as IRootieComponent<any>,
  ],
};
